import authValidateTokenLoader from './authValidateTokenLoader';
import { AUTH_VALIDATE_ROUTE_PATHNAME } from '../routePathnames';
import { AUTH_VALIDATE_ROUTE_ID } from 'constants/routeIds';
import { FullScreenLoader } from '@router/components/SuspenseLoader';

export const authRoutes = [
  {
    id: AUTH_VALIDATE_ROUTE_ID,
    path: AUTH_VALIDATE_ROUTE_PATHNAME,
    element: <FullScreenLoader />,
    loader: authValidateTokenLoader,
  },
];
